import './style.scss'
import React, { useState,useCallback } from 'react'
import { I18n } from 'react-redux-i18n'

import { apiConversation } from 'api'
import { getStaticImage } from 'utils/statics'

/**
 * @param {object} props
 * @param {string} props.userId
 * @param {string} props.height
 */
function ChatSyncAccount(props) {
  const { userId, height } = props

  const [inSync, setInSync] = useState(false)
  const [message, setMessage] = useState('sync_started')

  const syncMessages = useCallback(async () => {
    if (inSync) return

    setInSync(true)

    try {
      setMessage('sync_started')

      await apiConversation.conversations.msgSync(userId)
    } catch (error) {
      setMessage(error?.response?.data?.type || '')
    }

    setTimeout(() => setInSync(false), 3000)
  }, [userId, inSync])

  return (
    <button
      title={I18n.t('dashboard_sync')}
      className='chat-composer__reload-msg'
      onClick={syncMessages}
    >
      <figure
        style={{
          height: height || '15px'
        }}
      >
        {inSync ? (
          <img
            className='chat-composer__reload-msg__sync-icon'
            src={getStaticImage('/icons/orange-brand/sync-primary.svg')}
            alt='Sync'
          />
        ) : (
          <img
            src={getStaticImage('/icons/orange-brand/sync-grey.svg')}
            alt='Sync'
          />
        )}
      </figure>
      {inSync && <span className='chat-composer__reload-msg__sync-message'>{I18n.t(message)}</span>}
    </button>
  )
}

export default ChatSyncAccount
